/**
 * Rapor görüntüleyicisini KULLANICI İSTEMEDEN ÖNCE hazırlar.
 *
 * Görüntüleyici DevExpress'in üç ağır paketine dayanıyor: üretim derlemesinde dx-core
 * 6,4 MB (1,5 MB gzip) ve dx-reporting 2,4 MB (457 KB gzip) — yani rapora ilk basışta
 * ~2 MB indirilip ~9 MB JavaScript ayrıştırılıyor. Bu iş rapor düğmesine basıldıktan
 * SONRA başladığı için gecikme tamamen kullanıcının beklediği süreye biniyordu.
 *
 * Çözüm indirmeyi öne almak: rapor işlemi olan bir ekran açıldığında, tarayıcı boşa
 * düştüğü ilk anda paketler arka planda indirilir. Kullanıcı rapora bastığında modül
 * zaten belleklidir ve açılış ağ beklemesiz olur.
 *
 * Dikkat edilenler:
 *   - Yalnızca RAPORU OLAN ekranlarda tetiklenir; rapor açmayan kullanıcıya 2 MB
 *     indirtmek kötü bir takas olurdu.
 *   - Kotalı/yavaş bağlantılarda (Network Information API) hiç yapılmaz.
 *   - Boşta zamanı beklenir: ekranın kendi verisi ve grid çizimi önce bitsin.
 */
let started = false;

interface NetworkInformation {
  saveData?: boolean;
  effectiveType?: string;
}

/** Kullanıcı veriden tasarruf istiyorsa ya da bağlantı yavaşsa ön yükleme yapılmaz. */
function connectionAllowsPrefetch(): boolean {
  const connection = (navigator as Navigator & { connection?: NetworkInformation }).connection;
  if (!connection) return true;
  if (connection.saveData) return false;
  return !/2g/.test(connection.effectiveType ?? '');
}

function whenIdle(run: () => void) {
  const idle = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number })
    .requestIdleCallback;
  if (idle) idle(run, { timeout: 4000 });
  else window.setTimeout(run, 1500);
}

/**
 * Görüntüleyici paketlerini bir kez, arka planda indirir. Birden çok ekran çağırsa da
 * tek seferlik; hata yutulur çünkü bu yalnızca bir hızlandırma, işlevin koşulu değil.
 */
export function prefetchReportViewer(): void {
  if (started || typeof window === 'undefined') return;
  if (!connectionAllowsPrefetch()) return;
  started = true;

  whenIdle(() => {
    void import('../ui/ReportViewerHost').catch(() => {
      // İndirilemezse kullanıcı rapora bastığında normal yol (lazy import) devreye girer.
      started = false;
    });
  });
}

/** Testler için: modül durumunu sıfırlar. */
export function resetPrefetchForTest(): void {
  started = false;
}
